import { memo } from "react";

const LoadingElement = memo(() => (
  <li className="animate-pulse py-6">
    <div className="flex animate-pulse space-x-4">
      <div className="flex-1 space-y-6 py-1">
        <div className="h-2 max-w-sm rounded bg-slate-200"></div>
        <div className="space-y-3">
          <div className="grid grid-cols-3 gap-4">
            <div className="col-span-2 h-2 rounded bg-slate-200"></div>
            <div className="col-span-1 h-2 rounded bg-slate-200"></div>
          </div>
          <div className="h-2 rounded bg-slate-200"></div>
        </div>
        <div className="h-2 max-w-sm rounded bg-slate-200"></div>
      </div>
    </div>
  </li>
));

LoadingElement.displayName = "LoadingElement";

const ResultsLoading: React.FC = () => (
  <ul className="bg-defaultBg mx-auto mb-10 divide-y-2 divide-dashed divide-lightGray rounded-3xl px-4 py-8 md:px-10">
    <LoadingElement />
    <LoadingElement />
    <LoadingElement />
    <LoadingElement />
    <LoadingElement />
    <LoadingElement />
    <LoadingElement />
    <LoadingElement />
  </ul>
);

export default ResultsLoading;
